import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";

function SEO({ desc, lang, meta, title, pathname, keywords }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
            metakeywords
          }
        }
      }
    `
  );

  const metaDescription = desc || site.siteMetadata.description;
  const metaTitle = title || site.siteMetadata.title;
  const metaKeywords = keywords || site.siteMetadata.metakeywords;
  const pageLink =
    `${site.siteMetadata.siteUrl}/${pathname}` || site.siteMetadata.siteUrl;
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `keywords`,
          content: metaKeywords,
        },
        {
          name: `copyright`,
          content: `© 2020 receiptmaker.netlify.app`,
        },
        {
          property: `og:title`,
          content: metaTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:url`,
          content: pageLink,
        },
        {
          property: `og:image`,
          content: `${site.siteMetadata.siteUrl}/social-media-cover-image.jpg`,
        },
        {
          property: `og:site_name`,
          content: `ReceiptMaker`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: metaTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:url`,
          content: pageLink,
        },
        {
          name: `twitter:image`,
          content: `${site.siteMetadata.siteUrl}/social-media-cover-image.jpg`,
        },
      ].concat(meta)}
    >
      <link rel="canonical" href={pageLink}></link>
    </Helmet>
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  pathname: ``,
  keywords: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  pathname: PropTypes.string,
  keywords: PropTypes.string,
};

export default SEO;
